import { ref, Ref } from 'vue';
import { EmergencyAlert } from '@/components/emergency-alert/types/emergency-alerts';

type EmergencyAlertsFile = {
    emergencyAlerts: EmergencyAlert[];
};

const emergencyAlerts: Ref<EmergencyAlert[]> = ref([]);

const getEmergencyAlerts = (): EmergencyAlert[] => [...emergencyAlerts.value];

const initEmergencyAlerts = async (): Promise<void> => {
    try {
        const file: Response = await fetch('/emergency-alerts.json');
        const content: EmergencyAlertsFile = await file.json();
        if (content.emergencyAlerts.length) {
            emergencyAlerts.value = content.emergencyAlerts;
        }
    } catch (error: unknown) {
        console.error('Unable to fetch emergency alerts from file: ', error);
    }
};

export { initEmergencyAlerts, getEmergencyAlerts };
